import { useState, useEffect, useRef, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import { verify2FA, select2FA } from '../../store/twoFAlice';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import JwtService from '../../auth/services/jwtService';
import { showMessage } from "app/store/fuse/messageSlice";


const OtpInput = ({ value, onChange, onKeyDown, inputRef, disabled }) => {
    return (
        <TextField
            inputRef={inputRef}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            disabled={disabled}
            color="secondary"
            inputProps={{
                maxLength: 1,
                style: { textAlign: 'center', fontSize: '1.5rem', padding: '0 0 8px 0' },
                type: 'text',
            }}
            variant="standard"
        />
    );
};


function TwoFaVerifyPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, verified, error } = useSelector(select2FA);
    const [code, setCode] = useState(Array(6).fill(''));
    const inputsRef = useRef([]);

    const location = useLocation();
    const email = location?.state?.email;
    const password = location?.state?.password;

    // useEffect(() => {
    //     if (verified) {
    //         navigate('/dashboard');
    //     }
    // }, [verified, navigate]);

    const handleChange = (e, idx) => {
        const val = e.target.value.replace(/\D/g, '');
        const newCode = [...code];

        newCode[idx] = val ? val[0] : '';
        setCode(newCode);

        if (val && idx < code.length - 1) {
            inputsRef.current[idx + 1].focus();
        }
    };


    const handleKeyDown = (e, idx) => {
        if (e.key === 'Backspace' && !code[idx] && idx > 0) {
            const newCode = [...code];
            newCode[idx - 1] = '';
            setCode(newCode);
            inputsRef.current[idx - 1].focus();
        }
    };

    const handleVerify = () => {
        if (code.every(digit => digit !== '')) {
            dispatch(verify2FA({ token: code.join(''), email, password })).unwrap().then((res) => {
                if (!res?.errors) {
                    JwtService.twoFaLogin(res)
                }
            }).catch((_errors) => {
                if (Array.isArray(_errors)) {
                    _errors.forEach((error) => {
                        if (error?.type == "blocked") {
                            dispatch(showMessage({ message: error?.message, variant: "error" }));
                        } else if (error?.type == "deleted") {
                            dispatch(showMessage({ message: error?.message, variant: "error" }));
                        } else if (error?.type == "2Fa") {
                            dispatch(showMessage({ message: error?.message, variant: "warn" }));
                            navigate("/enable-2fa", { state: { email, password } });
                        } else if (error?.type == "2Fa Verify") {
                            dispatch(showMessage({ message: error.message, variant: "success" }));
                            navigate('/verify-2fa', { state: { email, password } });
                        } else {
                            setError(error?.type || "error", {
                                type: "manual",
                                message: error?.message,
                            });
                        }
                    });
                } else {
                    dispatch(showMessage({ message: _errors || "Verification Failed", variant: "error" }));
                }
            });
        }
    };

    return (
        <div className="flex flex-col items-center flex-auto min-w-0 sm:justify-center">
            <Paper className="w-full min-h-full px-16 py-32 sm:w-auto sm:min-h-auto rounded-0 sm:p-48 sm:rounded-2xl sm:shadow">
                <div className="flex flex-col items-center justify-center w-full mx-auto max-w-320 sm:w-320 sm:mx-0">
                    <img className="w-60" src="assets/images/logo/logo.svg" alt="logo" />

                    <Typography className="mt-16 text-center">
                        {email && password ? "Verify Authentication" : "Unauthenticated Access"}
                    </Typography>

                    {email && password && (
                        <>
                            <Typography className="mt-16 text-center">
                                Enter the 6-digit code generated by your Authenticator app.
                            </Typography>

                            <Box className="flex justify-between w-full max-w-xs gap-8 mx-auto mt-24">
                                {code.map((digit, idx) => (
                                    <OtpInput
                                        key={idx}
                                        value={digit}
                                        onChange={e => handleChange(e, idx)}
                                        onKeyDown={e => handleKeyDown(e, idx)}
                                        inputRef={el => (inputsRef.current[idx] = el)}
                                        disabled={loading}
                                    />
                                ))}
                            </Box>

                            <Button
                                className="py-10 mt-24"
                                variant="contained"
                                color="secondary"
                                onClick={handleVerify}
                                disabled={loading || !code.every(d => d !== '')}
                            >
                                {loading ? 'Verifying...' : 'Verify'}
                            </Button>

                            {/* {error && (
                                <Typography className="mt-16 text-center text-red-600">{error}</Typography>
                            )} */}

                        </>
                    )}
                </div>
            </Paper>
        </div>
    );
}

export default TwoFaVerifyPage;
